import React, { useState } from "react";
import { getUserInfo, sendEmail } from "../services/api";
import { userHasSubscription } from "../user";

const SUBJECTS = [
  { value: "neil",      label: "Letters for Neil",            subscribersOnly: true },
  { value: "archivist", label: "Question for the Archivist",  subscribersOnly: true },
  { value: "help",      label: "Customer Support",            subscribersOnly: false },
  { value: "billing",   label: "Billing Issue",               subscribersOnly: false },
  { value: "data",      label: "Question about Data Usage",   subscribersOnly: false },
];

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const ResponsiveContact = () => {
  const info = getUserInfo();
  const initialEmail = (info.user_metadata && info.user_metadata.customEmail) || info.email || "";

  const [name,        setName]        = useState(info.name || "");
  const [email,       setEmail]       = useState(initialEmail);
  const [body,        setBody]        = useState("");
  const [subject,     setSubject]     = useState("help");
  const [showPicker,  setShowPicker]  = useState(false);
  const [status,      setStatus]      = useState("idle"); // idle | loading | success | error
  const [errors,      setErrors]      = useState({});

  const selectedLabel = SUBJECTS.find(s => s.value === subject)?.label || "Select a Subject";

  const validate = () => {
    const errs = {};
    if (!subject)                    errs.subject = "Select a subject";
    if (!name.trim())                errs.name    = "Required";
    if (!emailRegex.test(email))     errs.email   = "Invalid email";
    if (!body.trim())                errs.body    = "Required";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubjectSelect = (opt) => {
    if (opt.subscribersOnly && !userHasSubscription()) {
      window.subs && window.subs();
      setShowPicker(false);
      return;
    }
    setSubject(opt.value);
    setErrors(prev => ({ ...prev, subject: undefined }));
    setShowPicker(false);
  };

  const handleSubmit = async () => {
    if (status === "loading") return;
    if (!validate()) return;

    let to = subject;
    if (["neil", "archivist"].includes(subject) && userHasSubscription()) {
      to = subject + "-subscribers";
    }

    setStatus("loading");
    try {
      await sendEmail({ name, from: email, body, subject: to, to });
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div className="contact-page responsive-page">
        <div className="contact-result">
          <p>Your message was sent. Thanks!</p>
        </div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="contact-page responsive-page">
        <div className="contact-result">
          <p>Your message failed to send. Please try again.</p>
          <button className="contact-retry-btn" onClick={() => setStatus("idle")}>Try Again</button>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-page responsive-page">
      {/* Subject picker overlay */}
      {showPicker && (
        <div className="contact-picker-overlay" onClick={() => setShowPicker(false)}>
          <div className="contact-picker" onClick={e => e.stopPropagation()}>
            <div className="contact-picker-title">Select Subject</div>
            {SUBJECTS.map(opt => (
              <div
                key={opt.value}
                className={`contact-picker-option${subject === opt.value ? " selected" : ""}`}
                onClick={() => handleSubjectSelect(opt)}
              >
                {opt.label}
                {subject === opt.value && <i className="check icon" />}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="contact-form-wrapper">
        {/* Name */}
        <div className={`contact-row${errors.name ? " has-error" : ""}`}>
          <label>First name</label>
          <input
            type="text"
            placeholder=""
            value={name}
            onChange={e => { setName(e.target.value); setErrors(prev => ({ ...prev, name: undefined })); }}
          />
          {errors.name && <span className="contact-error">{errors.name}</span>}
        </div>

        {/* Email */}
        <div className={`contact-row${errors.email ? " has-error" : ""}`}>
          <label>Email</label>
          <input
            type="email"
            placeholder=""
            value={email}
            onChange={e => { setEmail(e.target.value); setErrors(prev => ({ ...prev, email: undefined })); }}
          />
          {errors.email && <span className="contact-error">{errors.email}</span>}
        </div>

        {/* Subject */}
        <div
          className={`contact-row contact-row--nav${errors.subject ? " has-error" : ""}`}
          onClick={() => setShowPicker(true)}
        >
          <label>Subject</label>
          <div className="contact-row-nav-content">
            <span className={subject ? "contact-row-value" : "contact-row-placeholder"}>{selectedLabel}</span>
            <span className="contact-row-chevron">&#8250;</span>
          </div>
          {errors.subject && <span className="contact-error">{errors.subject}</span>}
        </div>

        {/* Message */}
        <div className={`contact-row contact-row--textarea${errors.body ? " has-error" : ""}`}>
          <textarea
            placeholder="Write your text here"
            value={body}
            onChange={e => { setBody(e.target.value); setErrors(prev => ({ ...prev, body: undefined })); }}
          />
          {errors.body && <span className="contact-error">{errors.body}</span>}
        </div>

        <div className="contact-submit-row">
          <button
            className="contact-submit-btn"
            onClick={handleSubmit}
            disabled={status === "loading"}
          >
            {status === "loading" ? "SENDING..." : "SEND MESSAGE"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveContact;
